import { Component } from '@angular/core';

@Component({
    selector: 'app-mp-total-revenue',
    imports: [],
    templateUrl: './mp-total-revenue.component.html',
    styleUrl: './mp-total-revenue.component.scss'
})
export class MpTotalRevenueComponent {}